import type { ReactNode } from 'react';

export function SectionEyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[color:var(--v2-mute)]">
      {children}
    </span>
  );
}
